import { TCreateCompanyReqDto, TCreateCompanyResDto } from "@/api/services/main/company/dtos/create-company.dto";
import { clientApi } from "@/utils/api";

/** ACC20A02 取引先登録 — POST /company。 */
export const createCompanyApi = async (payload: TCreateCompanyReqDto): Promise<TCreateCompanyResDto> => {
  const { data } = await clientApi.post<TCreateCompanyResDto>("/company", payload);
  return data;
};
